import { Link } from "@inertiajs/react";

type Props = {
  loginUrl: string;
};

export default function DomainClaimHeader({ loginUrl }: Props) {
  return (
    <div className="relative z-50 shrink-0 border-b border-gray-200 bg-white">
      <div className="container mx-auto flex flex-col gap-3 px-4 py-3 sm:flex-row sm:items-center sm:justify-between md:px-6">
        <div className="min-w-0">
          <p className="text-sm font-semibold text-primary">ScoutUX</p>
          <p className="text-sm text-gray-700">
            Create an account to keep this report. Subscribe to cover journeys after they log in.
          </p>
        </div>
        <Link href={loginUrl} className="btn btn-primary w-full shrink-0 sm:w-auto">
          Keep this report
        </Link>
      </div>
    </div>
  );
}
